import api, { API_ENDPOINTS } from '../config/api';

const authService = {
  // Register new user
  register: async (email, fullName, password) => {
    try {
      const response = await api.post(API_ENDPOINTS.register, {
        email,
        fullName,
        password
      });
      
      console.log('[AuthService] Register response:', response.data);
      
      // Handle different response structures
      const token = response.data?.token || 
        response.data?.data?.token ||
        response.data?.access_token ||
        response.data?.data?.access_token ||
        response.data?.accessToken ||
        response.data?.data?.accessToken;
      const user = response.data?.user || response.data?.data?.user || response.data;
      
      if (token) {
        console.log('[AuthService] Saving token to localStorage');
        localStorage.setItem('token', token);
        
        // Save user data (exclude password)
        const userData = {
          email: user.email,
          fullName: user.fullName || user.full_name || user.name,
          id: user.id || user._id
        };
        
        console.log('[AuthService] Saving user data:', userData);
        localStorage.setItem('user', JSON.stringify(userData));
        
        // Verify it was saved
        const savedToken = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');
        console.log('[AuthService] Verification - Token saved:', !!savedToken, 'User saved:', !!savedUser);
      } else {
        console.error('[AuthService] No token in response:', response.data);
      }
      
      return response.data;
    } catch (error) {
      console.error('[AuthService] Register error:', error);
      throw error.response?.data || error;
    }
  },

  // Login user
  login: async (email, password) => {
    try {
      const response = await api.post(API_ENDPOINTS.login, {
        email,
        password
      });
      
      console.log('=====================================');
      console.log('[AuthService] LOGIN RESPONSE FULL DATA:');
      console.log(JSON.stringify(response.data, null, 2));
      console.log('[AuthService] Response top-level keys:', Object.keys(response.data));
      console.log('[AuthService] Response status:', response.status);
      console.log('[AuthService] Response headers Authorization:', response.headers?.authorization);
      console.log('=====================================');
      
      // Handle different response structures
      const token = response.data?.token || 
            response.data?.data?.token || 
            response.data?.access_token || 
            response.data?.data?.access_token ||
            response.data?.accessToken ||
            response.data?.data?.accessToken;
      const user = response.data?.user || response.data?.data?.user || response.data;
      
      console.log('[AuthService] Token extraction result:', {
        tokenExists: !!token,
        tokenType: typeof token,
        tokenLength: token?.length || 0,
        tokenPreview: token ? token.substring(0, 30) + '...' : 'NO TOKEN'
      });
      console.log('[AuthService] User extraction result:', user);
      
      if (token) {
        console.log('[AuthService] ✓ TOKEN FOUND - Saving to localStorage');
        localStorage.setItem('token', token);
        
        // Save user data (exclude password)
        const userData = {
          email: user.email,
          fullName: user.fullName || user.full_name || user.name,
          id: user.id || user._id
        };
        
        console.log('[AuthService] Saving user data:', userData);
        localStorage.setItem('user', JSON.stringify(userData));
        
        // Verify it was saved
        const savedToken = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');
        console.log('[AuthService] VERIFICATION - Token saved:', !!savedToken, 'User saved:', !!savedUser);
      } else {
        console.error('✗✗✗ [AuthService] NO TOKEN FOUND ✗✗✗');
        console.error('[AuthService] Full response:', response.data);
        console.error('[AuthService] Response structure:', {
          hasToken: !!response.data.token,
          hasDataToken: !!response.data.data?.token,
          hasAccessToken: !!response.data.access_token,
          hasDataAccessToken: !!response.data.data?.access_token,
          hasAccessTokenAlt: !!response.data.accessToken
        });
      }
      
      return response.data;
    } catch (error) {
      console.error('[AuthService] Login error:', error);
      throw error.response?.data || error;
    }
  },

  // Logout user
  logout: async () => {
    try {
      const token = localStorage.getItem('token');
      await api.post(API_ENDPOINTS.logout, {}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('admin_token'); // Remove admin token on logout
      console.log('[AuthService] Logged out - cleared token, user, and admin_token');
    }
  },

  // Get stored user
  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Get token
  getToken: () => {
    return localStorage.getItem('token');
  },

  // Check if user is logged in
  isLoggedIn: () => {
    return !!localStorage.getItem('token');
  }
};

export default authService;
